export const safeGet = (path, object) => path.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), object)

export const IsValidJSONString = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
